import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import CredibilityStats from './components/CredibilityStats';
import WhatWeBuild from './components/WhatWeBuild';
import HowWeWork from './components/HowWeWork';
import Testimonials from './components/Testimonials';
import ServiceArea from './components/ServiceArea';
import Footer from '../../components/feature/Footer';
import Navigation from '../../components/feature/Navigation';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <CredibilityStats />
      <WhatWeBuild />
      <HowWeWork />
      <Testimonials />
      <ServiceArea />
      <Footer />
    </div>
  );
}